// extracted by mini-css-extract-plugin
export default {"pagesContainer":"Guidelines_pagesContainer__PLLOl","guidelinesCell":"Guidelines_guidelinesCell__7LMFD"};